<template>
	<div v-if="transactionId">
		<div id="contentToPrint" class="pdf-a4">
			<!-- Header -->
			<div class="pdf-header">
				<img :src="customThemeEnabled ? `${appBaseUrl}assets/custom/images/header_payment_proof.png` : require('@/assets/custom/images/header_payment_proof.png')" alt="Logo">
			</div>
			<!-- Main Content -->
			<div v-if="documentConfig?.dataDetails" class="pdf-content">
				<v-row justify="center">
					<v-col v-if="documentConfig?.dataDetails" cols="12">
						<v-row>
							<v-col v-if="documentConfig.title" class="firstContentTitle" cols="12"  style="padding-bottom: 0 !important;">
								<h3>{{ documentConfig.title }}</h3>
								<br/>
								<hr style="border: none; border-top: 1px solid #ccc; margin: 0;" />
							</v-col> 
							<v-col class="first-section-content-wrapper padding-left pa-0" v-if="documentConfig?.titleContentDetails" cols="12">
								<v-layout row wrap>
									<v-flex v-for="(data, index) in documentConfig?.titleContentDetails" :key="index"
										class="content-details" xs12 sm6 md6 lg6 xl6>
										<p v-if="data?.label" class="label-display">{{ data.label }}</p>
										<p v-if="data?.value" class="value-display"> {{ data.value }}</p>
									</v-flex>
								</v-layout>
							</v-col>
							<v-col>
								<br />
							</v-col>
							<v-col v-if="documentConfig.contentTitle" class="secondContentTitle" cols="12"  style="padding-bottom: 0 !important;">
								<h3>{{ documentConfig.contentTitle }}</h3>
								<br/>
								<hr style="border: none; border-top: 1px solid #ccc; margin: 0;" />
							</v-col> 
							<v-col class="padding-left pa-0" v-if="documentConfig?.dataDetails" cols="12">
								<v-layout row wrap>
									<v-flex
										v-for="(data, index) in documentConfig?.dataDetails"
										:key="index"
										:class="['content-details']"
										xs12 sm6 md6 lg6 xl6
									>
										<p v-if="documentConfig?.dataListTranslation" class="label-display">{{
											$t(`${documentConfig?.dataListTranslation}.${data.label}`) }}</p>
										<p v-else class="label-display">{{ data.label }}</p>
										<p v-if="data?.subLabel" class="pa-0">{{ data.subLabel }}</p>
										<p v-if="data?.value" class="value-display"> {{ data.value }}</p>
										<p v-if="data?.subValue" class="sub-value-display"> {{ data.subValue }}</p>
									</v-flex>
								</v-layout>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</div>
			<!-- Footer -->
			<footer class="pdf-footer">
				<img :src="customThemeEnabled ? `${appBaseUrl}assets/custom/images/footer_payment_proof.png` : require('@/assets/custom/images/footer_payment_proof.png')" alt="Footer Image">
			</footer>
		</div>
	</div>
</template>

<script>
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import html2pdf from 'html2pdf.js';
import event from '@/util/event'

export default {
	props: {
		config: {
			type: Object,
			default() {
				return {}
			}
		}
	},
	components: {
		DisplayDetails
	},
	data() {
		return {
			transactionId: '',
			documentConfig: {}
		}
	},
	created() {
		event.$on('download_payment_proof', async (arg) => {
			if (arg) {
				this.documentConfig = arg
				this.transactionId = this.documentConfig?.transactionId
				await this.downloadPDF()
			}
		})
	},
	methods: {
		async downloadPDF() {
			// Wait for DOM and dynamic content to render
			await this.$nextTick();
			const element = document.getElementById('contentToPrint');
			const timestamp = new Date().toISOString().replace(/\D/g, '')
			setTimeout(() => {
				const opt = {
					margin: 1,
					filename: `${this.transactionId}-${timestamp}`,
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas: { scale: 2, useCORS: true, scrollY: 0 },
					jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', putOnlyUsedFonts: true }
				};
				html2pdf().set(opt).from(element).save();
			}, 200); // Add Delay Before Rendering
		}
	}
}
</script>
<style lang="scss" scoped>
.pdf-a4 {
	margin-bottom: 0in !important;
	margin-left: 0.25in;
	margin-right: 0.5in;
	margin-top: 0.5in;
}

.pdf-header,
.pdf-footer {
	text-align: center;
}

.align-center {
	text-align: center;
}

.pdf-header img {
	width: 100%;
	min-height: 100px;
}

.pdf-footer img {
	width: 100%;
	min-height: 60px;
}

.padding-left {
	padding-left: 26.5mm;
}

.firstContentTitle {
	padding-left: 23mm;
}

.secondContentTitle {
	padding-left: 23mm;
}

.first-section-content-wrapper {
	// padding-top: 2px;
	padding-bottom: 0px !important;
}

.uppercase-display {
	text-transform: uppercase;
}

.label-display {
	font-weight: bold;
	font-size: 15px;
	padding-top: 6mm;
	padding-bottom: 0.15mm;
}

.value-display {
	font-size: 15px;
}

.sub-value-display {
	font-size: 15px;
}

.pdf-content {
	min-height: 180mm;
	font-family: "Arial";
}

.content-details {
	display: grid;
	grid-template-columns: 1fr;
	gap: 0.8rem;
	color: #333;
}
</style>